import { ibkApi } from '@ibk/shared-config';
const parseContractPdfResponse = async (response) => {
    const contentType = response.headers.get('content-type') ?? '';
    return contentType.includes('application/pdf') ? response.blob() : response.json();
};
const buildGetContractPdfQuery = ({ contractId }) => ({
    url: `/v1/benefits/contracts/${contractId}/pdf`,
    method: 'POST',
    responseHandler: parseContractPdfResponse,
});
export const contractPdfApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        getEmissorContractPdf: build.mutation({
            query: buildGetContractPdfQuery,
        }),
    }),
    overrideExisting: false,
});
export const { useGetEmissorContractPdfMutation } = contractPdfApi;
